import { ArrowRight, ListPlus, PhoneCall, Telescope } from 'lucide-react';
import { Link } from 'react-router';

import { Button, cn } from '@workspace/shadcn';

import { useModals } from '../components/modals.tsx';
import { Section } from '../components/section.tsx';
import { BlurFade } from '../components/effects/blur-fade.tsx';
import { DotPattern } from '../components/effects/dot-pattern.tsx';

const steps = [
  {
    icon: Telescope,
    title: 'Explore Our Courses',
    description:
      'Browse our diverse range of cutting-edge courses designed for the MENA region haelthcare demands.',
  },
  {
    icon: ListPlus,
    title: 'Enroll in One or Multiple',
    description:
      'Choose as many courses as you need to meet your career goals.',
  },
  {
    icon: PhoneCall,
    title: 'Personalized Consultation',
    description:
      'Our team will reach out to discuss your aspirations and guide you towards the perfect learning path.',
  },
];

export function RegisterInterest() {
  const { open } = useModals();

  return (
    <Section>
      <DotPattern
        className={cn(
          '-z-10 [mask-image:radial-gradient(500px_circle_at_center,white,transparent)]',
        )}
      />
      <BlurFade delay={0.25} inView>
        <h2 className="text-center text-4xl font-bold tracking-tighter">
          Ready to Elevate Your Skills?
        </h2>
        <p className="text-muted-foreground mx-auto my-4 max-w-[640px] text-center">
          Harness your soft and technical skills to transform your career.
        </p>

        <div className="mx-auto mt-12 w-full max-w-5xl px-6 py-4">
          <div className="mt-10 grid gap-6 md:grid-cols-3">
            {steps.map((step) => (
              <div
                key={step.title}
                className="flex flex-col items-center text-center"
              >
                <div className="relative mb-4 rounded-full p-3">
                  <span className="bg-primary/25 dark:bg-primary/40 absolute inset-0 z-0 rounded-full opacity-60 blur dark:opacity-80" />
                  <span className="bg-primary/10 absolute inset-0 z-0 rounded-full" />
                  <step.icon className="text-primary relative z-10 size-8" />
                </div>
                <h3 className="mb-2 text-xl font-semibold">{step.title}</h3>
                <p className="text-muted-foreground text-base">
                  {step.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 flex flex-col items-center justify-center gap-4 md:flex-row">
            <Link to="/courses" className="text-center">
              <Button className="group/button h-12 px-8 text-base text-white dark:text-black">
                View All Courses
                <ArrowRight className="ms-2 h-4 w-4 transition-transform group-hover/button:translate-x-1" />
              </Button>
            </Link>
            <Button
              variant="outline"
              className="h-12 px-8 text-base"
              onClick={() => open('suggestion')}
            >
              Suggest a Course
            </Button>
          </div>
        </div>
      </BlurFade>
    </Section>
  );
}
